const loadVideoThumbnail = file =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = () => {
      const blob = new Blob([reader.result], { type: file.type });
      const url = URL.createObjectURL(blob);
      const video = document.createElement('video');

      video.addEventListener(
        'loadeddata',
        () => {
          const canvas = document.createElement('canvas');
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          canvas
            .getContext('2d')
            .drawImage(video, 0, 0, canvas.width, canvas.height);
          const imageUrl = canvas.toDataURL();
          if (
            imageUrl &&
            imageUrl.includes('data:image') &&
            !imageUrl.includes('YMGDAgAEDBgw') // HACK: iOS '직접 촬영' 영상 처리
          )
            resolve(imageUrl);
          else resolve(null);

          URL.revokeObjectURL(url);
        },
        { once: true }
      );
      video.preload = 'metadata';
      video.src = url;
      video.muted = true;
      video.playsInline = true;
      video.play().catch(() => resolve(null));
    };

    reader.readAsArrayBuffer(file);
  });

export { loadVideoThumbnail };
